import Vue from 'vue'
import Constants from 'src/utilities/constants'
import {OK} from 'http-status-codes'
import {make} from 'vuex-pathify'
import {resetState} from 'src/utilities/vuex2'
import {objectById, utcToLocal} from 'src/utilities/utils'

const initialState = {
  id: null,
  nameId: null,
  name: null,
  templateId: null,
  projectId: null,
  jobId: null,
  ownerId: null,
  assigneeId: null,
  camunda: {
    taskId: null,
    taskDefinitionKey: null,
    executionId: null,
    processInstanceId: null
  },
  status: null,
  priority: null,
  dueDate: null,
  completionDate: null,
  notes: '',
  completeLock: false,
  linkedTaskId: null,
  fieldValues: {},
  assignedAt: null,
  assignedBy: null,
  createdAt: null,
  createdBy: null,
  updatedAt: null,
  updatedBy: null
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)

getters.getTask = (state) => {
  return state
}
getters.notes = (state) => { // ckeditor can't handle a null
  return state.notes || ''
}

const mutations = make.mutations(state)

mutations.reset = resetState

mutations.task = (state, payload) => {
  Object.keys(state).forEach(key => {
    state[key] = payload[key]
  })

  if (state.notes == null) { //ckeditor does not handle null values
    state.notes = ''
  }

  if (state.dueDate) {
    state.dueDate = utcToLocal(state.dueDate)
  }
}

mutations.editFieldValue = (state, payload) => {
  state.fieldValues[payload.key] = payload.value
}

mutations.removeFieldValue = (state, fieldKey) => {
  delete state.fieldValues[fieldKey]
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchById({commit, dispatch, rootState}, id) {
      const response = await dispatch('fetchById', {endpoint: 'tasks', id}, {root: true})
      if (OK === response.status) {
        const task = response.data

        if (task.fieldValues == null) {
          task.fieldValues = {}
        }

        const taskTemplate = objectById(rootState.tasks.templates.results, task.templateId)
        if (taskTemplate) {
          commit('tasks/templates/activeTaskTemplate', JSON.parse(JSON.stringify(taskTemplate)), {root: true})
        }

        const taskTemplateFields = rootState.tasks.templates.active.fields

        if (taskTemplateFields) {
          for (let i = 0; i < taskTemplateFields.length; i++) {
            const taskTemplateField = taskTemplateFields[i]
            // make sure each dynamic field has at least an empty value, needed to connect component to vuex
            if (!task.fieldValues.hasOwnProperty(taskTemplateField.key)) {
              let defaultValue = null
              // null default values for inputs with multiple values blowing up element-ui
              if (Constants.COMPONENTS.SELECT_MULTIPLE === taskTemplateField.component
                || Constants.COMPONENTS.TAGS === taskTemplateField.component) {
                defaultValue = []
              }
              task.fieldValues[taskTemplateField.key] = defaultValue
            }

            // force boolean fields to have a boolean value to avoid null booleans or 0's or 1's being used instead
            if (taskTemplateField.component === Constants.COMPONENTS.CHECKBOX
              || taskTemplateField.component === Constants.COMPONENTS.SWITCH) {
              task.fieldValues[taskTemplateField.key] = !!task.fieldValues[taskTemplateField.key]
            }
          }
        }

        if (task.dueDate) {
          task.dueDate = utcToLocal(task.dueDate)
        }

        commit('task', task)
      }

      return response
    }
  }
}
